import { FilterTable } from '@/components/new/table/filter/FiltersRow'
import { Banknote, Tag } from 'lucide-react'
import { ICompany } from '../interfaces/interfaces'

export const mockedData: ICompany[] = [
  {
    id: 3,
    name: 'Importadora',
    type: 'PROVIDER',
    observations: 'Observation 1',
  },
  {
    id: 4,
    name: 'Importadora 1',
    type: 'PROVIDER',
    observations: 'Primer create',
  },
  {
    id: 1,
    name: 'Sales y azucar',
    type: 'PROVIDER',
    observations: 'Buena cerveza',
  },
]
